import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Paper,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Breadcrumbs,
  Link as MuiLink,
  Snackbar,
  Alert,
  IconButton,
  Avatar,
  CardActions,
  Fade,
  Slide
} from '@mui/material';
import {
  Work as WorkIcon,
  LocationOn as LocationIcon,
  AccessTime as TimeIcon,
  NavigateNext as NavigateNextIcon,
  Close as CloseIcon,
  CloudUpload as CloudUploadIcon,
  Schedule as ScheduleIcon,
  Business as BusinessIcon,
  Group as GroupIcon,
  TrendingUp as TrendingUpIcon,
  School as SchoolIcon,
  Star as StarIcon
} from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import careerBn from '../i18n/bn/career';
import careerEn from '../i18n/en/career';
import careerDe from '../i18n/de/career';
import careerNp from '../i18n/np/career';
import careerPk from '../i18n/pk/career';
import careerSl from '../i18n/sl/career';
import careerBt from '../i18n/bt/career';
import careerAf from '../i18n/af/career';
import careerCn from '../i18n/cn/career';

const Career = () => {
  const navigate = useNavigate();
  const currentLanguage = (typeof window !== 'undefined' && localStorage.getItem('preferredLanguage')) || 'bn';
  const t = currentLanguage === 'en' 
    ? careerEn 
    : currentLanguage === 'de' 
    ? careerDe 
    : currentLanguage === 'np' 
    ? careerNp 
    : currentLanguage === 'pk' 
    ? careerPk 
    : currentLanguage === 'sl' 
    ? careerSl 
    : currentLanguage === 'bt'
    ? careerBt
    : currentLanguage === 'af'
    ? careerAf
    : currentLanguage === 'cn'
    ? careerCn
    : careerBn;
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    experience: '',
    education: '',
    resume: null
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const jobs = (t.jobs || [
    {
      id: 1,
      title: 'সিনিয়র সফটওয়্যার ইঞ্জিনিয়ার',
      department: 'আইটি',
      location: 'ঢাকা',
      type: 'ফুল-টাইম',
      experience: '৫+ বছর',
      salary: '৮০,০০০ - ১,২০,০০০ টাকা',
      deadline: '৩০ এপ্রিল, ২০২৪',
      posted: '৫ দিন আগে',
      description: 'আমাদের টেক টিমে যোগ দিন। React, Node.js এবং Cloud সার্ভিসে অভিজ্ঞতা থাকতে হবে।',
      requirements: [
        'কমপক্ষে ৫ বছরের ওয়েব ডেভেলপমেন্ট অভিজ্ঞতা',
        'React, Node.js এ দক্ষতা',
        'AWS/GCP ক্লাউড সার্ভিসে অভিজ্ঞতা',
        'টিম লিডারশিপের অভিজ্ঞতা'
      ],
      benefits: [
        'প্রতিযোগিতামূলক বেতন',
        'স্বাস্থ্য বীমা',
        'বার্ষিক বোনাস',
        'ফ্লেক্সিবল ওয়ার্কিং আওয়ার'
      ],
      featured: true
    },
    {
      id: 2,
      title: 'মার্কেটিং ম্যানেজার',
      department: 'মার্কেটিং',
      location: 'ঢাকা',
      type: 'ফুল-টাইম',
      experience: '৩+ বছর',
      salary: '৫০,০০০ - ৮০,০০০ টাকা',
      deadline: '২৫ এপ্রিল, ২০২৪',
      posted: '৩ দিন আগে',
      description: 'ডিজিটাল মার্কেটিং স্ট্র্যাটেজি তৈরি ও বাস্তবায়নের জন্য অভিজ্ঞ মার্কেটিং ম্যানেজার প্রয়োজন।',
      requirements: [
        'ডিজিটাল মার্কেটিংয়ে ৩+ বছরের অভিজ্ঞতা',
        'সোশ্যাল মিডিয়া ক্যাম্পেইন পরিচালনার অভিজ্ঞতা',
        'টিম ম্যানেজমেন্ট স্কিল',
        'বাজেট পরিচালনার অভিজ্ঞতা'
      ],
      benefits: [
        'প্রতিযোগিতামূলক বেতন',
        'স্বাস্থ্য বীমা',
        'প্রশিক্ষণের সুযোগ'
      ],
      featured: false
    },
    {
      id: 3,
      title: 'কাস্টমার সার্ভিস এক্সিকিউটিভ',
      department: 'কাস্টমার সার্ভিস',
      location: 'ঢাকা',
      type: 'ফুল-টাইম',
      experience: '১+ বছর',
      salary: '২৫,০০০ - ৪০,০০০ টাকা',
      deadline: '২০ এপ্রিল, ২০২৪',
      posted: '১ দিন আগে',
      description: 'গ্রাহক সেবা প্রদানের জন্য উৎসাহী ও অভিজ্ঞ প্রার্থী প্রয়োজন।',
      requirements: [
        'কাস্টমার সার্ভিসে ১+ বছরের অভিজ্ঞতা',
        'উন্নত যোগাযোগ দক্ষতা',
        'ইংরেজি ও বাংলায় দক্ষতা',
        'কম্পিউটার দক্ষতা'
      ],
      benefits: [
        'প্রতিযোগিতামূলক বেতন',
        'স্বাস্থ্য বীমা',
        'ক্যারিয়ার গ্রোথের সুযোগ'
      ],
      featured: false
    }
  ]);

  const statIcons = [<GroupIcon />, <BusinessIcon />, <TrendingUpIcon />, <SchoolIcon />];
  const companyStats = (t.companyStats || []).map((s, i) => ({ icon: statIcons[i] || <GroupIcon />, value: s.value, label: s.label }));

  const handleApplyClick = (job) => {
    setSelectedJob(job);
    setOpenDialog(true);
  };

  const handleViewDetails = (jobId) => {
    navigate(`/career/job/${jobId}`);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedJob(null);
    setFormData({
      name: '',
      email: '',
      phone: '',
      experience: '',
      education: '',
      resume: null
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        resume: file
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Application submitted:', { ...formData, jobId: selectedJob.id });
    
    setSnackbar({
      open: true,
      message: t.snackbar?.success || 'Submitted successfully',
      severity: 'success'
    });

    handleCloseDialog();
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  return (
    <>
      <Header />
      <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
        {/* Hero Section */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            py: 8,
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <Container>
            <Breadcrumbs 
              separator={<NavigateNextIcon fontSize="small" />} 
              aria-label="breadcrumb"
              sx={{ mb: 4, '& .MuiBreadcrumbs-separator': { color: 'rgba(255,255,255,0.7)' } }}
            >
              <MuiLink component={Link} to="/" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                {t.breadcrumbs.home}
              </MuiLink>
              <Typography sx={{ color: 'white' }}>{t.breadcrumbs.career}</Typography>
            </Breadcrumbs>

            <Fade in timeout={1000}>
              <Box sx={{ textAlign: 'center', mb: 6 }}>
                <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 700, mb: 2 }}>
                  {t.hero.title}
                </Typography>
                <Typography variant="h5" sx={{ opacity: 0.9, maxWidth: { xs: '100%', md: '700px' }, mx: 'auto' }}>
                  {t.hero.subtitle}
                </Typography>
              </Box>
            </Fade>

            {/* Company Stats */}
            <Grid 
              container 
              spacing={4} 
              sx={{ mt: 4 }}
            >
              {companyStats.map((stat, index) => (
                <Grid item xs={12} sm={6} md={3} key={index} sx={{ display: 'flex' }}>
                  <Fade in timeout={1000 + index * 200}>
                    <Paper
                      sx={{
                        p: 3,
                        textAlign: 'center',
                        bgcolor: 'rgba(255,255,255,0.1)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255,255,255,0.2)',
                        color: 'white',
                        width: '100%',
                        height: '100%',
                        minHeight: 140,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: 'rgba(255,255,255,0.2)',
                          color: 'white',
                          mx: 'auto',
                          mb: 2,
                          width: 56,
                          height: 56
                        }}
                      >
                        {stat.icon}
                      </Avatar>
                      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                        {stat.value}
                      </Typography>
                      <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        {stat.label}
                      </Typography>
                    </Paper>
                  </Fade>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        {/* Job Listings Section */}
        <Container sx={{ py: 6 }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
              {t.jobsSection.title}
            </Typography>
            <Typography variant="h6" color="text.secondary">
              {t.jobsSection.subtitle}
            </Typography>
          </Box>

            <Grid container spacing={4} alignItems="stretch">
            {jobs.map((job, index) => (
              <Grid item xs={12} key={job.id} sx={{ width: '100%' }}>
                <Slide direction="up" in timeout={500 + index * 200}>
                  <Card
                    sx={{
                      position: 'relative',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: '0 12px 24px rgba(0,0,0,0.15)'
                      },
                      border: job.featured ? '2px solid #667eea' : '1px solid #e2e8f0',
                      overflow: 'visible',
                      width: '100%'
                    }}
                  >
                    {job.featured && (
                        <Chip
                        icon={<StarIcon />}
                        label="ফিচার্ড"
                        color="primary"
                        sx={{
                          position: 'absolute',
                          top: -12,
                          right: 20,
                          zIndex: 1,
                          fontWeight: 600
                        }}
                      />
                    )}
                    
                    <CardContent sx={{ p: 4 }}>
                      <Grid container spacing={3} sx={{ alignItems: 'stretch', justifyContent: 'space-between' }}>
                        <Grid item xs={12} md={8} sx={{ display: 'flex', flexDirection: 'column' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <Avatar
                              sx={{
                                bgcolor: 'primary.main',
                                mr: 2,
                                width: 48,
                                height: 48
                              }}
                            >
                              <WorkIcon />
                            </Avatar>
                            <Box>
                              <Typography variant="h5" sx={{ fontWeight: 600, mb: 0.5 }}>
                                {job.title}
                              </Typography>
                               <Typography variant="body2" color="text.secondary">
                                 {job.posted} {t.labels.postedSuffix}
                              </Typography>
                            </Box>
                          </Box>

                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 3 }}>
                            <Chip
                              icon={<BusinessIcon />}
                              label={job.department}
                              variant="outlined"
                              size="small"
                            />
                            <Chip
                              icon={<LocationIcon />}
                              label={job.location}
                              variant="outlined"
                              size="small"
                            />
                            <Chip
                              icon={<TimeIcon />}
                              label={job.type}
                              variant="outlined"
                              size="small"
                            />
                            <Chip
                              icon={<ScheduleIcon />}
                              label={job.experience}
                              variant="outlined"
                              size="small"
                            />
                          </Box>

                          <Typography variant="body1" paragraph sx={{ color: 'text.secondary' }}>
                            {job.description}
                          </Typography>

                          <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 600 }}>
                            {t.labels.salary}: {job.salary}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
                          <Paper
                            sx={{
                              p: 3,
                              bgcolor: '#f8fafc',
                              border: '1px solid #e2e8f0',
                              height: '100%',
                              width: { xs: '100%', md: 'auto' },
                              minWidth: { md: '280px' },
                              maxWidth: { md: '320px' }
                            }}
                          >
                            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600 }}>
                              {t.labels.deadline}
                            </Typography>
                            <Typography variant="body2" color="error.main" sx={{ mb: 3, fontWeight: 500 }}>
                              {job.deadline}
                            </Typography>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                              <Button
                                variant="contained"
                                fullWidth
                                size="large"
                                onClick={() => handleViewDetails(job.id)}
                                sx={{
                                  py: 1.5,
                                  fontWeight: 600,
                                  textTransform: 'none'
                                }}
                              >
                                {t.buttons.viewDetails}
                              </Button>
                              <Button
                                variant="outlined"
                                fullWidth
                                size="large"
                                onClick={() => handleApplyClick(job)}
                                sx={{
                                  py: 1.5,
                                  fontWeight: 600,
                                  textTransform: 'none'
                                }}
                              >
                                {t.buttons.apply}
                              </Button>
                            </Box>
                          </Paper>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Slide>
              </Grid>
            ))}
          </Grid>

          {/* Call to Action */}
          <Box sx={{ textAlign: 'center', mt: 8 }}>
            <Paper
              sx={{
                p: 6,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                borderRadius: 3
              }}
            >
              <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
                {t.cta.title}
              </Typography>
              <Typography variant="h6" sx={{ mb: 4, opacity: 0.9 }}>
                {t.cta.subtitle}
              </Typography>
              <Button
                variant="contained"
                size="large"
                component={Link}
                to="/contact"
                sx={{
                  bgcolor: 'white',
                  color: 'primary.main',
                  px: 4,
                  py: 1.5,
                  fontWeight: 600,
                  '&:hover': {
                    bgcolor: 'grey.100'
                  }
                }}
              >
                {t.cta.contact}
              </Button>
            </Paper>
          </Box>
        </Container>

        {/* Application Dialog */}
        <Dialog 
          open={openDialog} 
          onClose={handleCloseDialog}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: { borderRadius: 2 }
          }}
        >
          <DialogTitle sx={{ pb: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                {selectedJob?.title}{t.form.titleSuffix}
              </Typography>
              <IconButton onClick={handleCloseDialog}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ p: 3 }}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label={t.form.name}
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label={t.form.email}
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label={t.form.phone}
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label={t.form.education}
                    name="education"
                    multiline
                    rows={3}
                    value={formData.education}
                    onChange={handleChange}
                    required
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label={t.form.experience}
                    name="experience"
                    multiline
                    rows={4}
                    value={formData.experience}
                    onChange={handleChange}
                    required
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    component="label"
                    variant="outlined"
                    startIcon={<CloudUploadIcon />}
                    sx={{ mt: 1, py: 1.5, px: 3 }}
                  >
                    {t.form.uploadResume}
                    <input
                      type="file"
                      hidden
                      accept=".pdf,.doc,.docx"
                      onChange={handleFileChange}
                    />
                  </Button>
                  {formData.resume && (
                    <Typography variant="body2" sx={{ mt: 1, color: 'success.main' }}>
                      ✓ {formData.resume.name}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </form>
          </DialogContent>
          <DialogActions sx={{ p: 3 }}>
            <Button onClick={handleCloseDialog} size="large">
              {t.buttons.cancel}
            </Button>
            <Button 
              variant="contained" 
              onClick={handleSubmit}
              disabled={!formData.resume}
              size="large"
              sx={{ px: 4 }}
            >
              {t.buttons.submit}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Success Snackbar */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbar.severity}
            sx={{ width: '100%' }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
      <Footer />
    </>
  );
};

export default Career; 